import styled from "@emotion/styled";

export const Sidebar = styled.div`
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  overflow-y:auto;
`;
